import url from 'url';

const getDocHeight = function(doc) {
  doc = doc || document;
  // from http://stackoverflow.com/questions/1145850/get-height-of-entire-document-with-javascript
  var body = doc.body,
    html = doc.documentElement;
    // console.log(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
  var height = Math.max(body.scrollHeight, body.offsetHeight,
    html.clientHeight, html.scrollHeight, html.offsetHeight);
  return height;
}

function sendDocHeightMsg(e) {
  var ht = getDocHeight();
}

export default function notifyParentWindowOfSizeChange() {
  if (!window.postMessage) return;
  // const qs = url.parse(document.referrer)
  const qs = url.parse(window.location.href)
  // const host = qs.protocol+'//'+qs.host;
  const host = '*';
  // console.log(document.getElementById('App').offsetHeight, document.getElementById('App').scrollHeight)
  let scrollHeight = document.getElementById('App').offsetHeight
  // let scrollHeight = getDocHeight()
  // console.log(scrollHeight, scrollHeight2)


  let m = {
    'action': 'resize',
    'value': scrollHeight,
    'payload': 1
  }
  // m = JSON.stringify(m);
  // console.log(m, host)
  if (window.parent) {
    // console.log('PARENT FOUND', window.parent.postMessage)
    window.parent.postMessage(m, host);
    // window.parent.postMessage("loaded", "*")

  }
}



// WEBPACK FOOTER //
// ./src/helpers/notifyParentWindowOfSizeChange.js